export default "__VITE_ASSET__BxZ4WTlN__"